import { render, staticRenderFns } from "./element.vue?vue&type=template&id=973472ac&"
import script from "./element.vue?vue&type=script&lang=ts&"
export * from "./element.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('973472ac')) {
      api.createRecord('973472ac', component.options)
    } else {
      api.reload('973472ac', component.options)
    }
    module.hot.accept("./element.vue?vue&type=template&id=973472ac&", function () {
      api.rerender('973472ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/element.vue"
export default component.exports